export default __webpack_public_path__ + "static/media/1823.85e2184b.png";